import { WithContext as ReactTags } from 'react-tag-input';
import React from 'react';
import './tagInput.css';

const KeyCodes = {
  comma: 188,
  // eslint-disable-next-line no-magic-numbers
  enter: [10, 13],
};

const delimiters = [...KeyCodes.enter, KeyCodes.comma];
const handleShouldRenderSuggestions = (query) => true;

export default function TagInput({
  name,
  onTagAdded = (tag) => { },
  onTagDeleted = (index) => { },
  tags = [],
  suggestions = [],
  required = false,
  placeholder = '',
}) {

  return (
    <div>
      <ReactTags
        name={name}
        tags={tags}
        minQueryLength={1}
        suggestions={suggestions}
        handleAddition={onTagAdded}
        handleDelete={onTagDeleted}
        delimiters={delimiters}
        inputProps={{ className: 'form-control', required: required }}
        placeholder={placeholder}
        renderSuggestion={({ text }, query) => <div>{text}</div>}
        shouldRenderSuggestions={handleShouldRenderSuggestions}
        autofocus={false}
      />
    </div>
  )
};
